import React from "react";
import { Check, Loader2, X } from "lucide-react";

/** PLAN-COMPLETE §4 — THE TICKER.
 *
 *  It lives in the viewer's top bar: the top corner of the viewport, OUTSIDE the plan area. It is
 *  not positioned over the drawing, so it can never cover a mark, and because it is part of the
 *  bar rather than the scrolling stage it stays put through every pan and zoom at no cost.
 *
 *  Small on purpose: the count, Clear, Save. No panel and no list — the list is the FRS itself,
 *  which Save opens.
 */
export default function PlanTicker({ count, units, onClear, onSave, busy }) {
  if (!count) return null;
  return (
    <div className="flex items-center gap-1.5 rounded-full border border-emerald-600 bg-emerald-50 pl-2 pr-1 py-1 shadow-sm"
         data-testid="plan-ticker" data-count={count} data-units={units}>
      <span className="tabular-nums font-bold text-emerald-900 text-sm" data-testid="plan-ticker-count">{count}</span>
      <span className="text-[11px] text-emerald-800 leading-none">
        mark{count === 1 ? "" : "s"}
        {units !== count ? <span className="block">{units} unit{units === 1 ? "" : "s"}</span> : null}
      </span>
      <button type="button" onClick={onClear} disabled={busy} aria-label="Clear the ticker"
              className="h-8 w-8 grid place-items-center rounded-full text-emerald-800 hover:bg-emerald-100 disabled:opacity-40"
              data-testid="plan-ticker-clear"><X className="w-4 h-4" /></button>
      <button type="button" onClick={onSave} disabled={busy}
              className="h-8 px-3 rounded-full bg-emerald-700 text-white text-xs font-bold inline-flex items-center gap-1 disabled:opacity-60"
              data-testid="plan-ticker-save">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Check className="w-3.5 h-3.5" />} Save
      </button>
    </div>
  );
}
